    <template>
    <nav>
        <v-navigation-drawer v-model="drawer" app>
          <v-list dense rounded>
          <v-row class="text-center">
            <v-col>
              <Login/>
            </v-col>
          </v-row>
            <v-list-item
              v-for="sideMenuItem in computedSideMenuItems"
              :key="sideMenuItem.k || sideMenuItem.title"
              router
              :to="sideMenuItem.route"
            >
              <v-list-item-action>
                <v-icon>{{ sideMenuItem.icon }}</v-icon>
              </v-list-item-action>
              <v-list-item-content>
                <v-list-item-title>
                  <SiteText :k="sideMenuItem.k" tag="span">{{ sideMenuItem.title }}</SiteText>
                </v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </v-list>
          <v-list dense rounded>
            <v-list-item>
          <v-switch
            v-model="darkTheme"
            @click="changeTheme"
            color="success"
            hide-details
            class="ma-auto d-flex"
          >
            <template slot="label">
              <span class="text-button">
                <SiteText k="nav.darkTheme" tag="span">Тёмная тема</SiteText>
              </span>
            </template>
          </v-switch>
            </v-list-item>
          </v-list>
        </v-navigation-drawer>
    
        <v-app-bar app color="green darken-2" dark :src="require('@/assets/header-background.jpg')">
            <!-- <v-container class="d-inline-flex align-baseline"> -->
            <v-app-bar-nav-icon @click.stop="drawer = !drawer"></v-app-bar-nav-icon>
            <!-- <v-toolbar-title class="d-inline-flex"> -->
            <v-container class="pa-0 px-5 text-truncate fitcontent">
              <router-link to="/about" style="text-decoration: none; color: inherit">
                <span class="text-h5 font-weight-bold">
                  <SiteText k="nav.brand.left" tag="span">ДОСААФ</SiteText>
                </span>
                <span class="text-h5 font-weight-light ml-1">
                  <SiteText k="nav.brand.right" tag="span">Каменка</SiteText>
                </span>
              </router-link>
            </v-container>
            <!-- </v-toolbar-title> -->
    
            <!-- </v-container> -->
            <!-- <v-spacer></v-spacer> -->
            <!-- <v-card> -->
              <!-- <v-tabs centered class="hidden-sm-and-down">
                  <v-tab>Главная</v-tab>
                  <v-tab>Об автошколе</v-tab>
                  <v-tab>Документы</v-tab>
              </v-tabs> -->
            <!-- </v-card> -->
    
            <v-spacer></v-spacer>
            <v-container class="d-inline-flex fitcontent">
                <v-btn text class="hidden-sm-and-down" router to="/about">
                  <SiteText k="nav.top.about" tag="span">Автошкола</SiteText>
                </v-btn>
                <v-btn text class="hidden-sm-and-down" router to="/docs">
                  <SiteText k="nav.top.docs" tag="span">Документы</SiteText>
                </v-btn>
            <!-- <v-spacer></v-spacer> -->
                <v-btn text class="hidden-sm-and-down" router to="/events">
                  <SiteText k="nav.top.events" tag="span">События</SiteText>
                </v-btn>
                <Dropdown header-key="nav.top.categories" header-default="Категории" :items="dropdownItems"/>
                <Login :hiddenOnMobile="true"/>

                <v-btn v-if="LOGIN_STATE" text class="hidden-sm-and-down" router to="/admin/texts">
                  <v-icon left>mdi-pencil</v-icon>
                  <SiteText k="nav.top.texts" tag="span">Тексты</SiteText>
                </v-btn>

                <v-btn v-if="LOGIN_STATE" text class="hidden-sm-and-down" router to="/admin/staff">
                  <v-icon left>mdi-account-group</v-icon>
                  <SiteText k="nav.top.staff" tag="span">Персонал</SiteText>
                </v-btn>
            </v-container>
        </v-app-bar>
        <v-snackbar
          v-model="snackbar"
          rounded
          :top="$vuetify.breakpoint.xs"
          timeout="7000"
          transition="slide-y-reverse-transition"
        >
          <p class="text-body-1 text-sm-h6 pa-0 ma-0 text-center font-weight-light">
            {{ congratsMessage() }}
          </p>
    
          <template v-slot:action="{ attrs }">
            <v-btn
              color="pink"
              text
              v-bind="attrs"
              @click="snackbar = false"
            >
              <SiteText k="nav.snackbar.close" tag="span">Закрыть</SiteText>
            </v-btn>
          </template>
        </v-snackbar>
    </nav>
    </template>
    
    <script>
    import Dropdown from './Dropdown'
    import Login from './Login'
    import SiteText from './SiteText'
    import { mapGetters } from 'vuex'
    
    export default {
        components: {
          Dropdown,
          Login,
          SiteText,
        },
        computed: {
          ...mapGetters(['LOGIN_STATE']),
          computedSideMenuItems() {
            const base = Array.isArray(this.sideMenuItems) ? [...this.sideMenuItems] : []
            if (this.LOGIN_STATE) {
              base.push(
                { k: 'nav.drawer.texts', title: 'Тексты', icon: 'mdi-pencil', route: '/admin/texts' },
                { k: 'nav.drawer.staff', title: 'Персонал', icon: 'mdi-account-group', route: '/admin/staff' }
              )
            }
            return base
          },
        },
        data: () => ({
            foundationYear: 1955,
            drawer: false,
            darkTheme: false,
            snackbar: false,
            sideMenuItems: [
              { k: 'nav.drawer.about', title: 'Об автошколе', icon: 'mdi-domain', route: '/about' },
              { k: 'nav.drawer.docs', title: 'Документы', icon: 'mdi-file', route: '/docs' },
              { k: 'nav.drawer.events', title: 'Мероприятия', icon: 'mdi-calendar-text', route: '/events' },
              { k: 'nav.drawer.reviews', title: 'Отзывы', icon: 'mdi-comment-quote-outline', route: '/reviews' },
              { k: 'nav.drawer.programs', title: 'Образоват. программы', icon: 'mdi-bag-personal-outline', route: '/docs#course' },
              { k: 'nav.drawer.paid', title: 'Платные услуги', icon: 'mdi-toolbox-outline', route: '/docs#paid-service' },
              { k: 'nav.drawer.regulations', title: 'Положения', icon: 'mdi-text-box', route: '/docs#regulations' },
              { k: 'nav.drawer.local', title: 'Локальные документы', icon: 'mdi-file-document-outline', route: '/docs#local' },
            ],
            dropdownItems: [
              { k: 'nav.dropdown.a', title: 'Категория А', route: '/about#category-A' },
              { k: 'nav.dropdown.b', title: 'Категория B', route: '/about#category-B' },
              { k: 'nav.dropdown.c', title: 'Категория C', route: '/about#category-C' },
              { k: 'nav.dropdown.d', title: 'Категория D', route: '/about#category-D' },
              { k: 'nav.dropdown.e', title: 'Категория E', route: '/about#category-E' },
            ],
        }),
        mounted() {
          this.darkTheme = localStorage.getItem('theme') === 'dark'
          this.snackbar = !!this.congratsMessage()
        },
        methods: {
          changeTheme() {
            this.$vuetify.theme.dark = !this.$vuetify.theme.dark
            localStorage.setItem('theme', this.$vuetify.theme.dark ? 'dark' : 'light')
          },
          congratsMessage() {
            const difference = new Date().getFullYear() - this.foundationYear
            // this.snackbar = difference % 5 == 0
            // console.log(this.snackbar, difference % 5 == 0)
            return (difference % 5 == 0) && `В этом году нашей автошколе исполняется ${difference} лет!`
          }
        },
    }
    </script>
    
    <style>
    .fitcontent {
        max-width: fit-content !important;
    }
    </style>
    